import React from "react";

export const SeparadorPaginaPdf = ({ style }) => {
	return (
		<div style={{ width: "100%", position: "relative", ...style }}>
			<div style={{ height: "1em" }}></div>
		</div>
	);
};
